import React from 'react';
import { Handle, Position, NodeProps, Node } from '@xyflow/react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export interface WorkflowGroupNodeData extends Record<string, unknown> {
  label: string;
  // Where the single right outlet to Open attaches, so the Parked -> Open line stays straight.
  outletOffsetY?: number;
}

export type WorkflowGroupFlowNode = Node<WorkflowGroupNodeData, 'group'>;

// The Parked container fill. A soft warm shade so the group reads as one calm "held" area without a
// hard border competing with the lifecycle boxes; the uppercase title alone names it.
const PARKED_BG_LIGHT = '#efe1c9';
const PARKED_BG_DARK = '#3b3427';

// The Parked container: a lightly shaded labelled area that holds the parked boxes (rendered as
// child nodes on top) so the diagram draws one arrow into Open instead of five. Not itself selectable.
const WorkflowGroupNode: React.FC<NodeProps<WorkflowGroupFlowNode>> = ({ data }) => {
  const theme = useTheme();
  const bg = theme.palette.mode === 'dark' ? PARKED_BG_DARK : PARKED_BG_LIGHT;
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        borderRadius: 1,
        bgcolor: bg,
        pt: 0.5,
      }}
    >
      {/* Single outlet feeding Open, placed at Open's flow line. */}
      <Handle id="s-right" type="source" position={Position.Right} style={{ top: data.outletOffsetY, opacity: 0 }} isConnectable={false} />
      <Typography
        sx={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.4, color: 'text.secondary', textAlign: 'center', lineHeight: 1.2 }}
      >
        {data.label}
      </Typography>
    </Box>
  );
};

export default WorkflowGroupNode;
